<template>
  <div>
    <el-form class="table-search-bar"
             :model="searchForm"
             ref="searchForm"
             inline
             label-width="100px">
      <el-form-item label="物料名称"
                    prop="itemName">
        <el-input v-model="searchForm.itemName"
                  placeholder="请输入物料名称"
                  clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary"
                   @click="handleSearch"
                   icon="el-icon-search">查 询</el-button>
        <el-button type="primary"
                   @click="reset">重 置</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="list"
              style="width: 100%"
              tooltip-effect="light"
              :summary-method="getSummaries"
              show-summary
              border
              resizable>
      <el-table-column prop="reservoirAreaCode"
                       label="库区编码"
                       :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="reservoirAreaName"
                       label="库区名称"
                       :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="itemCode"
                       label="物料编码"
                       :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="itemName"
                       label="物料名称"
                       :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="quantity"
                       label="现有量"
                       :show-overflow-tooltip="true"></el-table-column>
    </el-table>
    <el-pagination class="pagination"
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   :page-sizes="[10, 20, 50, 100]"
                   :page-size="listState.pageSize"
                   layout="total, sizes, prev, pager, next, jumper"
                   :total="listState.total"
                   background>
    </el-pagination>
  </div>
</template>
<script>
import HttpUtil from '@/common/HttpUtil'
export default {
  name: 'materialCurrent',
  components: {
  },
  data () {
    return {
      searchForm: { itemName: '' },
      list: [],
      listState: {
        pageNo: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  mounted () {
    this.handleSearch()
  },
  methods: {
    reset () {
      this.$refs['searchForm'].resetFields()
      this.handleSearch()
    },
    handleSizeChange (val) {
      this.listState.pageNo = 1
      this.listState.pageSize = val
      this.handleSearch()
    },
    handleCurrentChange (val) {
      this.listState.pageNo = val
      this.handleSearch()
    },
    // 查询reservoirAreaCode: 'FLK',
    handleSearch () {
      const { itemName } = this.searchForm
      HttpUtil.post('manage/lifonda/inventoryShow/item', { ...this.listState, itemName }).then(res => {
        const { data } = res
        if (Array.isArray(data.list)) {
          this.list = data.list
        } else {
          this.list = []
        }
        this.listState.total = data.total || 0
      })
    },
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = data.map((item) => Number(item[column.property]))
        if (!values.every((value) => isNaN(value)) && index === 4) {
          sums[index] = values
            .reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)
            .toFixed(3)
        } else {
          sums[index] = ''
        }
      })
      return sums
    }
  }
}
</script>
<style lang="scss" scoped>
.upload-btn {
  display: inline-block;
}
.width100 {
  width: 100px;
}
.export-row {
  margin-top: 10px;
}
.mr10 {
  margin-right: 10px;
}
</style>
